<template>
  <form v-if="rsvpConfigsToSave" class="c-rsvp-config__body">
    <div class="columns is-multiline">
      <div class="column is-full">
        <span class="title-form">Preferências</span>
      </div>
      <div class="column is-full pt-5">
        <div class="field">
          <div class="control" autocomplete="off">
            <b-field
              :type="{
                'is-danger': validation.hasError(
                  'rsvpConfigsToSave.page_title'
                ),
              }"
              :message="{
                'Preenchimento obrigatório': validation.hasError(
                  'rsvpConfigsToSave.page_title'
                ),
              }"
              class="form-field"
            >
              <b-input
                v-model="rsvpConfigsToSave.page_title"
                @change.native="saveRsvpConfigs"
                class="has-value"
                name="title"
                type="text"
                maxlength="50"
                :has-counter="false"
              />
            </b-field>
            <label for="title" class="label">Título:</label>
          </div>
        </div>
      </div>

      <div class="column is-full pt-5">
        <div class="field">
          <div class="control" autocomplete="off">
            <textarea
              rows="2"
              ref="FocusOnError"
              v-model="rsvpConfigsToSave.page_introduction"
              class="input has-value outlined-field"
              @change="saveRsvpConfigs"
              type="text"
              name="intro"
              maxlength="800"
              placeholder="Escreva aqui uma introdução"
            />
            <label for="intro" class="label has-text-left"
              >Introdução (opcional)</label
            >
          </div>
        </div>
      </div>

      <div class="column is-full">
        <div class="field">
          <div class="control outlined-body" autocomplete="off">
            <div class="is-flex is-align-items-center label-group">
              <tag-icon class="mr-4" icon="painel/id-icon" />
              <p
                for="completeName"
                class="has-text-weight-bold has-text-left has-space-bottom"
              >
                Solicitar o nome completo
              </p>
            </div>
            <div class="input input-select">
              <b-select
                name="completeName"
                v-model="
                  rsvpConfigsToSave.preferences.opened.require_guest_names
                "
                @change.native="saveRsvpConfigs"
              >
                <option selected :value="1" class="select-items">
                  De quem preencheu o formulário e os acompanhantes
                </option>
                <option :value="0" class="select-items">
                  Apenas de quem preencheu o formulário
                </option>
              </b-select>
            </div>
          </div>
        </div>
      </div>

      <div class="column is-full">
        <div class="field">
          <div class="control outlined-body" autocomplete="off">
            <div class="is-flex is-align-items-center label-group">
              <tag-icon class="mr-4" />
              <p
                for="maxAdults"
                class="has-text-weight-bold has-text-left has-space-bottom"
              >
                Máximo de adultos por confirmação
              </p>
            </div>
            <div class="input input-select">
              <b-select
                @change.native="saveRsvpConfigs"
                name="maxAdults"
                v-model="rsvpConfigsToSave.preferences.opened.limit_adults_qty"
              >
                <option
                  class="select-items"
                  v-for="item in maxAdults"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </option>
              </b-select>
            </div>
          </div>
        </div>
      </div>

      <div class="column is-full">
        <div class="field">
          <div class="control outlined-body" autocomplete="off">
            <div class="is-flex is-align-items-center label-group">
              <tag-icon icon="painel/child-icon" class="mr-4" />
              <p
                for="maxChildren"
                class="has-text-weight-bold label--double-row has-text-left has-space-bottom"
              >
                Máximo de crianças por confirmação
              </p>
            </div>
            <div class="input input-select">
              <b-select
                @change.native="saveRsvpConfigs"
                v-model="
                  rsvpConfigsToSave.preferences.opened.limit_children_qty
                "
              >
                <option selected :value="0" class="select-items">0</option>
                <option
                  v-for="item in maxChildren"
                  :key="item"
                  :value="item"
                  class="select-items"
                  name="maxChildren"
                >
                  {{ item }}
                </option>
              </b-select>
            </div>
          </div>
        </div>
      </div>

      <div
        class="column is-full"
        v-if="rsvpConfigsToSave.preferences.opened.limit_children_qty > 0"
      >
        <div class="field">
          <div class="control outlined-body" autocomplete="off">
            <div class="is-flex is-align-items-center label-group">
              <tag-icon icon="painel/child-icon" class="mr-4" />
              <p
                for="childrenAge"
                class="has-text-weight-bold has-space-bottom"
              >
                Informar idade máxima para crianças
              </p>
            </div>
            <div class="input input-select">
              <b-select
                @change.native="saveRsvpConfigs"
                name="childrenAge"
                v-model="rsvpConfigsToSave.preferences.opened.minimum_age_child"
              >
                <option selected :value="0" class="select-items">
                  Prefiro não informar
                </option>
                <option
                  v-for="item in maxAgeChildren"
                  :key="item"
                  :value="item"
                  class="select-items"
                  name="childrenAge"
                >
                  {{ item }}
                </option>
              </b-select>
            </div>
          </div>
        </div>
      </div>

      <div class="column is-full">
        <div class="control form-switch outlined-body">
          <div class="is-flex is-align-items-center label-group">
            <tag-icon icon="painel/message-icon" class="mr-4" />
            <p for="check-obs" class="has-text-weight-bold">
              Incluir campo aberto de observação para o convidado inserir
              comentários extras
            </p>
          </div>
          <div>
            <b-switch
              id="check-obs"
              @change.native="saveRsvpConfigs"
              v-model="rsvpConfigsToSave.preferences.opened.show_obs"
            />
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TagIcon from './TagIcon.vue'
import RsvpApi from '@/lib/api/Rsvp'
import SimpleVueValidator from 'simple-vue-validator'
const Validator = SimpleVueValidator.Validator
export default {
  mixins: [SimpleVueValidator.mixin],

  components: {
    TagIcon,
  },

  validators: {
    'rsvpConfigsToSave.page_title': (value) => {
      return Validator.value(value).required()
    },
  },

  computed: {
    ...mapGetters({
      logonToken: 'app/logonToken',
      wedSiteInfo: 'app/getWedSiteInfo',
      rsvpConfigs: 'getRsvpConfigs',
    }),
  },

  data() {
    return {
      maxAdults: 9,
      maxChildren: 10,
      maxAgeChildren: 18,
      rsvpConfigsToSave: undefined,
      configsInitialJsonCopy: undefined,
    }
  },

  watch: {
    rsvpConfigs(payload) {
      this.rsvpConfigsToSave = payload
    },
  },

  mounted() {
    this.rsvpConfigsToSave = {
      ...this.rsvpConfigs,
      mode: 'opened',
    }
    this.configsInitialJsonCopy = JSON.stringify(this.rsvpConfigs)
  },

  methods: {
    ...mapActions({
      notification: 'app/setNotification',
      setSaving: 'gifts/setSaving',
      setRsvpConfigs: 'setRsvpConfigs',
    }),

    saveRsvpConfigs() {
      if (this.rsvpConfigsToSave.page_title && this.hasChanges()) {
        this.setSaving(true)

        if (this.rsvpConfigsToSave.preferences.opened.minimum_age_child === 0) {
          this.rsvpConfigsToSave.preferences.opened.minimum_age_child =
            undefined
        }

        const rsvpApi = new RsvpApi(this.logonToken)
        rsvpApi
          .setConfigRsvp(this.rsvpConfigsToSave)
          .then((response) => {
            if (response.status === 201) {
              this.setRsvpConfigs(this.rsvpConfigsToSave)
              this.configsInitialJsonCopy = JSON.stringify(
                this.rsvpConfigsToSave
              )

              this.notification({
                message: 'Configurações salvas com sucesso!',
                show: true,
              })
            }
          })
          .catch(() => {
            this.notification({
              message: 'Erro no salvamento. Por favor, tente novamente.',
              show: true,
              class: 'is-error',
            })
          })
          .finally(() => {
            this.setSaving(false)
          })
      }
    },

    hasChanges() {
      return (
        this.configsInitialJsonCopy !== JSON.stringify(this.rsvpConfigsToSave)
      )
    },
  },
}
</script>

<style lang="scss"></style>
